import { postRequest } from "../utils/request";

export const firePageOpened = uuid => postRequest(`/session/${uuid}/events/open`);

export const firePageOpenedWithStatus = uuid => postRequest(`/session/${uuid}/events/status-open`);